module.exports = __webpack_public_path__ + "static/media/code_execution.63df3768.png";